import { Range } from "react-range";
import Thumb from "./Thumb";
import Track from "./Track";
type Props = {
  min: number;
  max: number;
  values: number[];
  onChange: (values: number[]) => void;
  step?: number;
  label: string;
  onFinalChange?: (values: number[]) => void;
}

const RateSlider = (props: Props) => {
  const { min, max, values, onChange, step = 1, label, onFinalChange } = props;
  const isRtl = document.querySelector('html')?.getAttribute('dir') === 'rtl'

  // Calculate effective min and max to handle out-of-range values
  const effectiveMin = Math.min(min, ...values);
  const effectiveMax = Math.max(max, ...values);

  return (
    <div>
      <Range
        step={step}
        rtl={isRtl}
        min={effectiveMin}
        max={effectiveMax}
        values={values}
        onChange={onChange}
        onFinalChange={onFinalChange}
        renderTrack={({ props, children }) => (
          <Track min={effectiveMin} max={effectiveMax} values={values} trackProps={props}>
            {children}
          </Track>
        )}
        renderThumb={({ props: { key, ...otherProps } }) => (
          <Thumb key={key} label={label} {...otherProps} />
        )}
      />
    </div>
  )
}

export default RateSlider
